exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-layout.toggle-aside{margin-left:110px}.page-layout{margin-left:280px;transition-duration:.3s}.page-layout .page-layout-wrap .page-layout-content{margin-top:50px;width:100%;display:inline-block;background-color:#f5f5f5;padding:20px}.page-layout .page-layout-wrap .page-layout-content .page-layout-bg{background-color:#fff;border:1px solid #e5e5e5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/layout/page-layout/page-layout.scss
// module id = 501
// module chunks = 2